<template>
  <div class="batch-order-main">
    <div class="top-section">
      <div class="selections">
        <Dropdown placeholder="Template" :items="templateList" itemKey="Template" :selectedObject.sync="selectedTemplate" :isDisabled="templateIsDisabled" />
        <DateTimePicker placeholder="Date" :showTime="false" :value.sync="istDate" />
        <Dropdown placeholder="Job Type" :items="jobTypeList" itemKey="Description" :selectedObject.sync="selectedJobType" />
        <Dropdown placeholder="Cust. No" :items="custNoList" itemKey="ShprCsgn Code" :selectedObject.sync="selectedCustNo" />
        <InputQuery placeholder="Bill Cust" :items="billCustList" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="selectedBillCust" />
        <InputQuery v-if="showPickup" placeholder="Pickup" :items="pickupList" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedPickup" />
        <InputQuery v-if="showTransit" placeholder="Transit" :items="transitList" itemKey="Destination Code" descKey="Company" :selectedObject.sync="selectedTransit" />
      </div>
      <div class="file-input">
        <Input textType="file" placeholder="Select File" :isDisabled="fileIsDisabled" @fileChanged="fileChanged" />
        <button @click="saveJobClicked" :disabled="istGeneratedData.length == 0">Save Job</button>
        <div class="message-container" :style="messsageBoxStyle" v-html="messageBoxText"></div>
      </div>
    </div>
    <div class="bottom-section">
      <div class="table-container">
        <TableBox title="Uploaded Data" :tableData="istGeneratedData" :dataType="{ 'SUM OF TB': 'number', 'SUM OF CTN': 'number' }" />
      </div>
      <div class="table-container">
        <TableBox title="Jobs" :tableData="jobsData" groupBy="Route" :dataType="{ 'Total CN': 'number', 'Total TB': 'number', 'Total CTN': 'number',
          'TB': 'number', 'CTN': 'number' }" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      templateList: [], selectedTemplate: null,
      istDate: null,
      jobTypeList: [], selectedJobType: null,
      billCustList: [], selectedBillCust: null,
      custNoList: [], selectedCustNo: null,
      destList: [], selectedDest: null,
      pickupList: [], selectedPickup: null,
      transitList: [], selectedTransit: null,
      
      showPickup: true,
      showTransit: false,

      selectedISTFile: null,
      istGeneratedData: [],
      jobsData: [],

      columnMapping: [
        {
          Template: 'Watsons IST Generated.',
          StartRow: 0,
          Sheet: 'Sheet1',
          GroupKey: 'STR_NO',
          mapping: [
            {
              name: 'ROUTE',
              possibleValues: [ 'ROUTE' ]
            },
            {
              name: 'STR_NO',
              possibleValues: [ 'STR_NO', 'STORE' ]
            },
            {
              name: 'MANIFEST NO',
              possibleValues: [ 'MANIFEST NO', 'MANIFEST' ]
            },
            {
              name: 'PCONTAINER',
              possibleValues: [ 'PCONTAINER', 'P_CONTAINER' ]
            },
            {
              name: 'IST',
              possibleValues: [ 'IST' ]
            },
            {
              name: 'SUM OF TB',
              possibleValues: [ 'SUM OF TB', 'TOTAL_TB', 'TOTEBOX', 'TB' ]
            },
            {
              name: 'SUM OF CTN',
              possibleValues: [ 'SUM OF CTN', 'TOTAL_CTN', 'CTN' ]
            },
          ]
        },
        {
          Template: 'DSM',
          StartRow: 2,
          Sheet: 'Data',
          GroupKey: 'Cust Ref/DO #',
          mapping: [
            {
              name: 'Cust Ref/DO #',
              possibleValues: [ 'CUSTOMER REFERENCE NO/ DO NO' ]
            },
            {
              name: 'Date Required',
              possibleValues: [ 'DATE REQUIRED' ]
            },
            {
              name: 'Time Required',
              possibleValues: [ 'TIME REQUIRED' ]
            },
            {
              name: 'Pickup',
              possibleValues: [ 'PICKUP CODE' ]
            },
            {
              name: 'Dropoff',
              possibleValues: [ 'DROPOFF CODE' ]
            },
            {
              name: 'Qty',
              possibleValues: [ 'QUANTITY' ]
            },
            {
              name: 'Product',
              possibleValues: [ 'PRODUCT CODE/ DESCRIPTION' ]
            },
            {
              name: 'Pkg Type',
              possibleValues: [ 'PACKAGE TYPE/UOM' ]
            },
            {
              name: 'Truck Type',
              possibleValues: [ 'TRUCK TYPE' ]
            },
            {
              name: 'Total KG',
              possibleValues: [ 'Total KG' ]
            },
            {
              name: 'Total M3',
              possibleValues: [ 'TOTAL M3' ]
            },
            {
              name: 'Req Time Desc',
              possibleValues: [ 'REQUIRED TIME DESC.' ]
            },
            {
              name: 'Remarks',
              possibleValues: [ 'REMARKS' ]
            },
            {
              name: 'Request By',
              possibleValues: [ 'REQUEST BY' ]
            },
            {
              name: 'Container #',
              possibleValues: [ 'CONTAINER NO' ]
            },
          ]
        }
      ],

      messageBoxText: '',
      messageBoxType: '',
    }
  },
  props: {
  },
  computed: {
    fileIsDisabled: function() {
      let isDisabled = !this.selectedTemplate || !this.istDate || !this.selectedJobType || !this.selectedCustNo || !this.selectedBillCust;
      if (this.showPickup) {
        isDisabled = this.selectedPickup ? false : true;
      }
      if (this.showTransit) {
        isDisabled = this.selectedTransit ? false : true;
      }

      return isDisabled;
    },
    messsageBoxStyle: function() {
      if (this.messageBoxType == 'success') {
        return {
          backgroundColor: 'rgba(50, 205, 50, 0.4)'
        }
      } else if (this.messageBoxType == 'error') {
        return {
          backgroundColor: 'rgba(205, 92, 92, 0.4)'
        }
      } else {
        return {
          backgroundColor: 'rgba(255, 246, 121, 0.4)'
        }
      }
    }
  },
  methods: {
    fileChanged: async function(files, placeholder) {
      this.showMessage();
      if (files.length > 0) {
        this.istGeneratedData = [];
        let excelJSON = await this.$excelToJson(files[0]);
        let template = this.columnMapping.find(f => f['Template'] == this.selectedTemplate['Template']);
        let columnMapping = template?.['mapping'];
        columnMapping.forEach(c => delete c['key']);
        
        if (excelJSON['success']) {
          let jsonData = excelJSON['data'];
          let sheet = jsonData.find(j => j['sheet'] == template['Sheet']);
          if (sheet) {
            let sheetData = sheet['data'];
            let keys = Object.keys(sheetData[0])
            let values = Object.values(sheetData[0])
            
            values.forEach((v, i) => {
              let mapped = columnMapping.find(c => c['possibleValues'].includes(v.toUpperCase()));
              if (mapped) {
                mapped['key'] = keys[i];
              }
            });

            let finalJson = sheetData.map(s => {
              let obj = {};
              columnMapping.forEach(c => {
                if (s[c['key']]) {
                  obj[c['name']] = s[c['key']]
                } else {
                  if (c['name'] == 'SUM OF TB' || c['name'] == 'SUM OF CTN' || c['name'] == 'Total KG' || c['name'] == 'Total M3') {
                    obj[c['name']] = 0;
                  } else if (c['name'] == 'Date Required') {
                    obj[c['name']] = this.istDate.formatString('yyyy-MM-dd');
                  } else if (c['name'] == 'Time Required') {
                    obj[c['name']] = '0000';
                  } else {
                    obj[c['name']] = '';
                  }
                }
              });
              return obj;
            });

            if (template['Template'] == 'Watsons IST Generated.') {
              finalJson = finalJson.filter(f => typeof f['ROUTE'] == 'number');
            }

            if (template['StartRow'] != 0) {
              finalJson = finalJson.slice(template['StartRow']);
            }

            this.istGeneratedData = finalJson;
            this.selectedISTFile = files[0];
            this.templateIsDisabled = true;

            this.$fullscreenLoading('Getting Data');
            this.populateJobData(await this.getTMSJob()); //add it in for dsm template
            this.$fullscreenLoading('');
          } else {
            this.showMessage('error', 'Cannot find the correct sheet within the excel file.<br>Please double check your excel file.');
          }
        } else {
          this.showMessage('error', 'Please double check your excel file to make sure that it is the right format.')
        }
      } else {
        this.istGeneratedData = [];
        this.selectedISTFile = null;
        this.templateIsDisabled = false;
      }
    },
    getTMSJob: async function() {
      if (this.selectedCustNo && this.istDate) {
        let rotnoarr = '';
        let jobdate = this.istDate.formatString('yyyy-MM-dd');
        if (this.selectedTemplate['Template'] == 'DSM' && this.istGeneratedData.length > 0) {
          rotnoarr = this.istGeneratedData.map(m => m['Cust Ref/DO #']).join(',');
          jobdate = '';
        }
        return await this.$apiCallV2('/BatchOrder/GetTMSJob', {
          jobdate: jobdate,
          system: 'TMS',
          cu_number: this.selectedCustNo['ShprCsgn Code'], 
          rotnoarr: rotnoarr
        });
      } else {
        return null;
      }
    },
    populateJobData: function(jobs) {
      this.jobsData = [];
      if (!jobs) { return }

      if (jobs['TransportJob']) {
        let trimmedJobs = this.$deepTrimJsonV3(jobs['TransportJob']['Job']);
        let final = trimmedJobs.map(j => {
          let obj = [];
          if (Array.isArray(j['Consignment'])) {
            j['Consignment'].forEach(c => obj.push({ ...j, ...c }));
          } else {
            obj.push({ ...j, ...j['Consignment'] });
          }

          obj.forEach(o => delete o['Consignment']);
          return obj;
        });
        
        this.$nextTick(() => {
          final = final.flat(Number.POSITIVE_INFINITY);
          this.jobsData = final.map((f, i) => { return { '#': i + 1, ...f } });
        });
      }
    },
    saveJobClicked: async function() {
      this.$fullscreenLoading('Getting Jobs List');
      let previousJobs = await this.getTMSJob();
      this.$fullscreenLoading();
      let groupKey = this.columnMapping.find(f => f['Template'] == this.selectedTemplate['Template'])?.['GroupKey'];
      let groupedStrNo = [...new Set(this.istGeneratedData.map(i => i[`${groupKey}`]))];
      let newISTList = {};
      groupedStrNo.forEach(g => newISTList[g] = this.istGeneratedData.filter(i => i[`${groupKey}`] == g));

      let jobList = [];
      for (let n in newISTList) {
        jobList.push(this.createJobBatch(newISTList[n]));
      }

      //check if same DO # must have same pickup and drop off
      if (this.selectedTemplate['Template'] == 'DSM') {
        let diffPickupDropoff = [];
        jobList.forEach(j => {
          if (j['consignment'].length > 0) {
            j['consignment'].forEach(c => {
              if (c['cnpickup'].toUpperCase() != j['pickup'].toUpperCase() || c['cndropoff'].toUpperCase() != j['dropoff'].toUpperCase()) {
                diffPickupDropoff.push({
                  'custref': j['custref'],
                  'jobpickup': j['pickup'], 
                  'jobdropoff': j['dropoff'],
                  'cnpickup': c['cnpickup'],
                  'cndropoff': c['cndropoff']
                })
              }
            })
          }
        })

        if (diffPickupDropoff.length > 0) {
          let tableString = '';
          tableString = '<table style="width:100%" border="1"><tr><th>Cust Ref/DO #</th><th>Pickup</th><th>CN Pickup</th></th><th>Dropoff</th><th>CN Dropoff</th></tr>';
          diffPickupDropoff.forEach(s => {
            tableString = `${tableString}<tr><td>${s['custref']}</td><td>${s['jobpickup']}</td><td>${s['cnpickup']}</td><td>${s['jobdropoff']}</td><td>${s['cndropoff']}</td></tr>`
          });
          tableString = `${tableString}</table>`;

          let diffMessage = `Cannot have Cust Ref/DO # with different pickup or dropoff location.\n${tableString}`

          await this.$showAlert('warning', 'Validation checking', diffMessage);
          return;
        }
      }

      if (previousJobs['TransportJob']) { // Has previous job
        previousJobs = this.$deepTrimJsonV3(previousJobs['TransportJob']['Job']);
        let hasOverlap = [];
        if (this.selectedTemplate['Template'] == 'DSM') {
          hasOverlap = previousJobs.map(p => p['Rot']).filter(p => jobList.map(j => j['custref']).includes(p));
        } else {
          hasOverlap = previousJobs.map(p => p['DestinationCode']).filter(p => jobList.map(j => j['dropoff']).includes(p));
        }
        hasOverlap = [...new Set(hasOverlap)];
        
        if (hasOverlap.length > 0) { // When there is an overlap of the route number
          // let overrideMessage = 'Are you sure you want to override previous record?';
          let buttonOptions = [];
          let overrideMessage = 'Do you want to override previous record or save as new record?';
          if (this.selectedTemplate['Template'] == 'Watsons IST Generated.') {
            buttonOptions = [
              { text: 'Override', color: 'red', textColor: 'white' },
              { text: 'Save as New', color: 'blue', textColor: 'white' }, 
              { text: 'Cancel', color: 'gray', textColor: 'white' }
            ];
            overrideMessage = 'Records exist in system from previous uploaded IST. ';
            let sameStoreDetailsArray = [];
            hasOverlap.forEach(o => {
              let same = false;
              let oldjob = previousJobs.find(p => p['DestinationCode'] == o);
              let newjob = jobList.find(j => j['dropoff'] == o);
              oldjob['Consignment'].forEach(c => {
                let oldManifestNo = c['ManifestNo'] ? c['ManifestNo'].trim() : '';
                let oldIstNo = c['IST No'] ? c['IST No'].trim() : '';
                newjob['consignment'].forEach(c1 => {
                  let newManifestNo = c1['manifestno'] ? c1['manifestno'].toString().trim() : '';
                  let newIstNo = c1['istno'] ? c1['istno'].toString().trim() : '';
                  if ((oldManifestNo == newManifestNo && (oldManifestNo != '' && newManifestNo != '')) 
                    || (oldIstNo == newIstNo && (oldIstNo != '' && newIstNo != ''))) {
                    same = true;
                    let tempObject = {
                      store: o,
                      manifestno: newManifestNo,
                      istno: newIstNo
                    }
                    sameStoreDetailsArray.push(tempObject);
                  }
                });
              });
            });
            if (sameStoreDetailsArray) {
              if (sameStoreDetailsArray.length > 0) {
                let tableString = '';
                tableString = '<table style="width:100%" border="1"><tr><th>Store</th><th>Manifest No</th><th>IST No</th></tr>';
                sameStoreDetailsArray.forEach(s => {
                  tableString = `${tableString}<tr><td>${s['store']}</td><td>${s['manifestno']}</td><td>${s['istno']}</td></tr>`
                });
                tableString = `${tableString}</table>`;
                overrideMessage = `${overrideMessage}\nThere are stores with same details(Manifest No, IST No) as existing records.\nDuplicate Records (${sameStoreDetailsArray.length} Records)\n${tableString}`
              } else {
                overrideMessage = `${overrideMessage}\nNo details(Manifest No, IST No) match with existing records.`;
              }
            }
          }
          else if (this.selectedTemplate['Template'] == 'DSM') {
            buttonOptions = [
              { text: 'Save as New', color: 'blue', textColor: 'white' }, 
              { text: 'Cancel', color: 'gray', textColor: 'white' }
            ];

            // overrideMessage = 'Records with same ROT # detected. ';
            let sameRotNoArray = [];
            hasOverlap.forEach(o => {
              let oldJob = previousJobs.filter(f => f['Rot'] == o);
              oldJob.forEach(f => {
                let tempObject = {
                  jobno: f['Job No'],
                  rotno: f['Rot']
                }
                sameRotNoArray.push(tempObject);
              });
            })

            if (sameRotNoArray.length > 0) {
              let tableString = '';
              tableString = '<table style="width:100%" border="1"><tr><th>Job #</th><th>DO #</th><tr/>';
              sameRotNoArray.forEach(f => {
                tableString = `${tableString}<tr><td>${f['jobno']}</td><td>${f['rotno']}</td></tr>`
              })
              tableString = `${tableString}</table>`;
              overrideMessage = `There are job with same ROT # as existings records.\nDuplicate Records (${sameRotNoArray.length} Records)\n${tableString}`;
            }
          }

          let continueSave = await this.$showAlert('warning', 'Record already exist!', overrideMessage, buttonOptions);

          if (continueSave == 'Override') {
            hasOverlap.forEach(o => {
              let jobNo = previousJobs.find(p => p['DestinationCode'] == o);
              let jobToChange = jobList.find(j => j['dropoff'] == o);
              if (jobToChange) {
                jobToChange['jobno'] = jobNo['Job No'];
                jobToChange['action'] = 'E';
              }
            });
          } else if (continueSave == 'Save as New') {
            //do nothing and save as new Job...
          } else if (continueSave == 'Cancel') {
            return;
          }
        }
      }
      
      let dataToPost = {
        'system': 'TMS',
        'jobdate': this.istDate.formatString('yyyy-MM-dd'),
        'docatt' : this.selectedISTFile['name'].split('.')[0],
        'attfile' : (await this.selectedISTFile.toBase64()).split(',')[1],
        'filetype' : `.${this.selectedISTFile['name'].split('.').pop()}`,
        'filename': this.selectedTemplate['Template'],
        'job': jobList,
      };

      this.$fullscreenLoading('Saving Job');

      let postUpdate = await this.$apiCallV2('/BatchOrder/SaveIST', dataToPost);
      this.$fullscreenLoading();

      if (postUpdate[0].ErrMsg) {
        this.showMessage('error', postUpdate[0]['ErrMsg']);
      } else if (postUpdate.includes('error')) {
        this.showMessage('error', postUpdate.split(':')[1]);
      } else {
        this.showMessage('success', postUpdate);
        this.$fullscreenLoading('Getting Jobs List');
        this.populateJobData(await this.getTMSJob());
        this.$fullscreenLoading();
      }
    },
    createJobBatch: function(istList) {
      let batchJob = {};
      if (this.selectedTemplate['Template'] == 'Watsons IST Generated.') {
        let sumTB = istList.map(i => i['SUM OF TB']).reduce((a, b) => a + b, 0);
        let sumCTN = istList.map(i => i['SUM OF CTN']).reduce((a, b) => a + b, 0);

        let batchCNList = istList.map(i => {
          return {
            'istno': i['IST'], 
            'pcontainer': i['PCONTAINER'],
            'manifestno': i['MANIFEST NO'], 
            'cntb': i['SUM OF TB'], 
            'cnctn': i['SUM OF CTN'], 
            'cntotal': i['SUM OF TB'] + i['SUM OF CTN'],
            'transit1': this.selectedTransit ? this.selectedTransit['Destination Code'] : '',
          }
        });

        let dropOffM = 'M';
        let length = 3 - istList[0]['STR_NO'].toString().length;
        for (let xx = length; xx > 0; xx--) {
          dropOffM += '0';
        }
        dropOffM += istList[0]['STR_NO'];

        batchJob = {
          'action': 'N', 
          'route': istList[0]['ROUTE'],
          'store': istList[0]['STR_NO'], 
          'totaltb': sumTB, 
          'totalctn': sumCTN, 
          'cu_number': this.selectedCustNo['ShprCsgn Code'],
          'jobtype': this.selectedJobType['Job Type'],
          'remarks1': '',
          'remarks2':'',
          'billcu_no': this.selectedBillCust['Customer Code'].trim(),
          'totalsum': sumTB + sumCTN,
          'bookingsource': 'W',
          'pickup': this.selectedPickup['Destination Code'].trim(),
          'dropoff': dropOffM,
          'jobno': '',
          'consignment': batchCNList,
        };
      } else {
        let totalSum = istList.map(i => i['Qty']).reduce((a, b) => a + b, 0);
        let totalKg = istList.map(i => i['Total KG']).reduce((a, b) => a + b, 0);
        console.log('istlist', istList);
        let batchCNList = istList.map(i => {
          return {
            'istno': '',
            'pcontainerno': i['Container #'],
            'manifestno': i['Product'],
            'cntb': '',
            'cnctn': '',
            'cntotal': i['Qty'],
            'transit1': this.selectedTransit ? this.selectedTransit['Destination Code'] : '',
            'packagecode': i['Pkg Type'],
            'cntotalkg': i['Total KG'],
            'cntotalm3': i['Total M3'],
            'reqdate': i['Date Required'],
            'reqtime': i['Time Required'],
            'reqtimedesc': i['Req Time Desc'],
            'trucktype': i['Truck Type'],
            'requestedby': i['Request By'],
            'cnpickup': i['Pickup'],
            'cndropoff': i['Dropoff'],
            'cnremark': i['Remarks']
          }
        });

        batchJob = {
          'action': 'N',
          'route': '',
          'store': istList[0]['Dropoff'],
          'totaltb': '',
          'totalctn': '',
          'cu_number': this.selectedCustNo['ShprCsgn Code'],
          'custref': istList[0]['Cust Ref/DO #'],
          'jobtype': this.selectedJobType['Job Type'],
          'remarks1': '',
          'remarks2': '',
          'billcu_no': this.selectedBillCust['Customer Code'],
          'totalsum': totalSum,
          'bookingsource': 'W',
          'pickup': istList[0]['Pickup'],
          'dropoff': istList[0]['Dropoff'],
          'jobno': '',
          'totalkg': totalKg,
          'consignment': batchCNList,
        }
      }

      return batchJob;
    },
    showMessage: function(type, text) {
      this.messageBoxText = text || '';
      this.messageBoxType = type || '';
    }
  },
  async mounted() {
    this.istDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);

    this.$fullscreenLoading('Getting data');
    this.templateList = this.$deepTrimJsonV3(await this.$apiCallV2('/BatchOrder/GetListMaster?masterFile=TEMPLATE_TMSJOB'));
    if (this.templateList.length == 1) {
      this.selectedTemplate = this.templateList[0];
    }
    this.jobTypeList = this.$deepTrimJsonV3(await this.$apiCallV2('/BatchOrder/GetListMaster?masterFile=jobtype'));
    
    let billCustList = this.$deepTrimJsonV3(await this.$apiCallV2('/BatchOrder/GetListMaster?masterFile=billcust'));
    this.billCustList = billCustList;

    let custNoList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHPRCSGN' });
    this.custNoList = custNoList;

    this.destList = this.$deepTrimJsonV3(await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'destination' }));
    this.transitList = this.$deepTrimJsonV3(await this.$apiCallV2('/BatchOrder/GetListMaster?masterFile=TRANSIT'));
    this.$fullscreenLoading();
  },
  watch: {
    selectedTemplate: function(val) {
      this.showPickup = val ? (val['Template'] == 'DSM' ? false : true) : true;
    },
    selectedJobType: function(val) {
      this.showTransit = val ? (val['Job Type'] == 'CD' ? true : false) : false;
    },
    selectedCustNo: async function(val) {
      if (val) {
        this.$fullscreenLoading('Getting Pickup List');
        this.pickupList = this.$deepTrimJsonV3(await this.$apiCallV2(`/BatchOrder/GetListMaster?masterFile=PICKUP_BYCUST&cu_number=${val['ShprCsgn Code']}`));
        this.$fullscreenLoading();

        if (this.pickupList.length == 1) {
          this.selectedPickup = this.pickupList[0];
        }

        this.$fullscreenLoading('Getting Job List');
        this.populateJobData(await this.getTMSJob());
        this.$fullscreenLoading();
      } else {
        this.selectedPickup = null;
      }
    },
    istDate: async function(val) {
      if (val) {
        this.$fullscreenLoading('Getting Job List');
        this.populateJobData(await this.getTMSJob());
        this.$fullscreenLoading();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.batch-order-main {
  padding: 10px 45px;
  font-size: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;

  > .top-section {
    background-color: white;
    border-radius: 5px;
    padding: 5px;

    > .selections {
      display: flex;
      align-items: flex-start;

      > :not(:first-child) {
        margin-left: 5px;
      }
    }

    > .file-input {
      display: flex;
      align-items: flex-start;

      > :first-child {
        max-width: calc(40% - 88px);
      }

      > :not(:first-child) {
        margin-left: 5px;
      }

      > button {
        white-space: nowrap;
      }

      > .message-container {
        min-width: 60%;
        min-height: 75px;
        max-height: 75px;
        overflow: auto;
        padding: 5px;
      }
    }
  }

  > .bottom-section {
    display: flex;
    align-items: center;
    margin-top: 5px;
    width: 100%;
    height: calc(100% - 114px);

    > .table-container {
      width: 50%;
      height: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;

      &:not(:first-child) {
        margin-left: 5px;
      }
    }
  }
}
</style>